import React from 'react'
import { Draggable } from 'react-beautiful-dnd'

const DraggableHeading = ({ heading, index, removeItem, column}) => (
    <Draggable
        key={heading}
        draggableId={heading}
        id={heading}
        index={index}
    >
        {(provided) => (
            <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className="draggable-column-heading"
            >
                <div className="draggable-handle">
                    <i className="fa-solid fa-grip-dots-vertical" />
                </div>
                <span>{heading}</span>
                {removeItem && column && (
                    <i
                        className="fal fa-times-circle"
                        onClick={removeItem}
                        data-index={index}
                        data-column={column}
                    />
                )}
            </div>
        )}
    </Draggable>
)

export default DraggableHeading
